import { json, type LinksFunction } from '@remix-run/node';
import stylesIndex from '~/styles/awards2024/policy.css';

export const links: LinksFunction = () => [
{
  rel: 'stylesheet',
  href: stylesIndex
}];


export async function loader() {
  return json({});
}

export default function PrivacyPolicyPage() {
  return (
    <div className='page-policy'>
      <div className="WordSection1">
        <p
          className="MsoNormal"
          align="center"
          style={{ fontSize: '', marginBottom: '12.0pt', textAlign: 'center' }}>

          <b>
      <span lang="EN-US" style={{ fontFamily: '"Calibri",sans-serif' }}>
        GWB Game Awards
      </span>
          </b>
          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '12.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          align="center"
          style={{ marginBottom: '12.0pt', textAlign: 'center' }}>

          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '12.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        COOKIES POLICY
      </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          align="center"
          style={{ marginBottom: '12.0pt', textAlign: 'center' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Last updated: 2024-0
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      3
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      -
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      08
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      This Cookies Policy applies
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      {' '}
            to the{' '}
    </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      GWB Game Awards program and its website ("Services")
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      .
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>
          </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      When you use the Services, we may use cookies, scripts and similar files
      or technologies
    </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      {' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      (collectively, "<b>cookies</b>") to collect and store information we
      automatically collect about your device and use of the Services.{' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      This Cookies Policy{' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      explains what cookies are, what kind of cookies may be used in our
      Services and how you can manage cookies.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      For the purposes of this Cookies Policy, "<b>we</b>", "<b>us</b>" and
      "<b>our</b>" means Proxima Beta Pte. Limited, a company incorporated in
      Singapore with the registered address at{' '}
    </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      10 Anson Road #21-07 International Plaza, Singapore.{' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      For the purpose of any personal data we collect through cookies, we are
      the data controller.
    </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Our{' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      data protection officer can be contacted{' '}
    </span>
          <span lang="EN-GB">
      <a href="#_CONTACT_US">
        <span
                lang="EN-US"
                style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

          here
        </span>
      </a>
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      .
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Our representative in the EU for the purpose of EU data protection laws is
      Proxima Beta Europe B.V., a company incorporated in the Netherlands with
      the
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      registered address at Buitenveldertselaan1-5, 1082 VA, Amsterdam, the
      Netherlands.{' '}
    </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Our UK representative for the purpose of UK data protection laws is Image
      Frame Investment (UK) Limited, a company incorporated in the United
      Kingdom with the registered address at Suite 1, 3rd Floor 11 - 12 St.
      James's Square, London, United Kingdom, SW1Y 4LB. Our EU and UK
      representatives and our data protection officer can be contacted
    </span>
          <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      {' '}
    </span>
          <span lang="EN-GB">
      <a href="#_CONTACT_US">
        <span
                lang="EN-US"
                style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

          here
        </span>
      </a>
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      .
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <h1
          style={{
            marginTop: '0cm',
            marginRight: '11.0pt',
            marginBottom: '11.0pt',
            marginLeft: '1.0cm',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-1.0cm'
          }}>

    <span lang="EN-US">
      1.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span lang="EN-US">WHAT ARE COOKIES?</span>
        </h1>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

          <a name="_Hlk113553824">
      <span
              lang="EN-US"
              style={{
                fontSize: '10.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        Cookies are files which are placed on your device when a website is
        loaded on your browser. They are widely used in order to make websites
        work or work more efficiently, as well as to provide information to the
        owner of the site or to another site that recognizes that cookie
      </span>
          </a>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      .
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '10.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        First-party and third-party cookies
      </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Cookies can be first-party or third-party. A first-party cookie is set
      directly by us to your device, whereas a third-party cookie is set by a
      third party (such as analytics providers and our advertisers and business
      partners).
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '10.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        Persistent and session cookies
      </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Cookies can be persistent or session cookies depending on the time that
      they remain on your device. A persistent cookie is stored on your device
      even after your web browser is closed or after your session ends. It can
      be used by the Services to recognize your device when you open your
      browser and use the Services again. A session cookie exists temporarily on
      your device while your browser is open. It is deleted automatically once
      you leave the website or close your browser.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            lineHeight: '12.0pt'
          }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      If you do not accept the use of cookies, please disable them using the
      instructions below and changing your browser settings so that cookies
      cannot be placed on your device.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <h1
          style={{
            marginTop: '0cm',
            marginRight: '11.0pt',
            marginBottom: '11.0pt',
            marginLeft: '1.0cm',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-1.0cm'
          }}>

    <span lang="EN-US">
      2.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span lang="EN-US">WHAT KIND OF COOKIES </span>
          <span lang="EN-US">DO WE USE?</span>
        </h1>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      The table
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      s
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      {' '}
            below explain the cookies used by us and our partners in connection with
      the Services.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '10.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        Strictly Necessary Cookies
      </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      These cookies are essential to the functioning of the Services, to provide
      a service requested by you or to comply with the law (e.g., security
      requirements of data protection laws).{' '}
    </span>
          <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      These cookies will be collected once our website is loaded on your browser
    </span>
          <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      {' '}
            and cannot be turned off as we cannot provide the Services without them.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '10.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        &nbsp;
      </span>
          </b>
        </p>
        <table
          className="MsoTableGrid"
          border={1}
          cellSpacing={0}
          cellPadding={0}
          width="99%"
          style={{ width: '99.76%', borderCollapse: 'collapse', border: 'none' }}>

          <tbody>
          <tr>
            <td
                width="18%"
                valign="top"
                style={{
                  width: '18.2%',
                  border: 'solid windowtext 1.0pt',
                  background: '#D9D9D9',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Cookie
            </span>
              </p>
            </td>
            <td
                width="26%"
                valign="top"
                style={{
                  width: '26.26%',
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#D9D9D9',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Cookie Name
            </span>
              </p>
            </td>
            <td
                width="40%"
                valign="top"
                style={{
                  width: '40.8%',
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#D9D9D9',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Purpose
            </span>
              </p>
            </td>
            <td
                width="14%"
                valign="top"
                style={{
                  width: '14.74%',
                  border: 'solid windowtext 1.0pt',
                  borderLeft: 'none',
                  background: '#D9D9D9',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Duration
            </span>
              </p>
            </td>
          </tr>
          <tr>
            <td
                width="18%"
                valign="top"
                style={{
                  width: '18.2%',
                  border: 'solid windowtext 1.0pt',
                  borderTop: 'none',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Tencent
            </span>
              </p>
              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              (First-Party)
            </span>
              </p>
            </td>
            <td
                width="26%"
                valign="top"
                style={{
                  width: '26.26%',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-GB"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              sid
            </span>
              </p>
            </td>
            <td
                width="40%"
                valign="top"
                style={{
                  width: '40.8%',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoListParagraph"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-GB"
                    style={{ fontFamily: '"Aptos",sans-serif', color: '#212121' }}>

              This cookie is used to store the login info of the user
            </span>
                <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              .
            </span>
              </p>
            </td>
            <td
                width="14%"
                valign="top"
                style={{
                  width: '14.74%',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Session
            </span>
              </p>
            </td>
          </tr>
          <tr>
            <td
                width="18%"
                valign="top"
                style={{
                  width: '18.2%',
                  border: 'solid windowtext 1.0pt',
                  borderTop: 'none',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Google{' '}
            </span>
              </p>
              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              (Third-Party)
            </span>
              </p>
            </td>
            <td
                width="26%"
                valign="top"
                style={{
                  width: '26.26%',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-GB"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              sid
            </span>
              </p>
            </td>
            <td
                width="40%"
                valign="top"
                style={{
                  width: '40.8%',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoListParagraph"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-GB"
                    style={{ fontFamily: '"Aptos",sans-serif', color: '#212121' }}>

              This cookie is used to store the login info of the user if login
              uses Google credential.
            </span>
              </p>
            </td>
            <td
                width="14%"
                valign="top"
                style={{
                  width: '14.74%',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid windowtext 1.0pt',
                  borderRight: 'solid windowtext 1.0pt',
                  background: 'white',
                  padding: '0cm 5.4pt 0cm 5.4pt'
                }}>

              <p
                  className="MsoNormal"
                  style={{
                    marginTop: '6.0pt',
                    marginRight: '0cm',
                    marginBottom: '6.0pt',
                    marginLeft: '0cm',
                    textAlign: 'justify',
                    textJustify: 'inter-ideograph'
                  }}>

            <span
                    lang="EN-US"
                    style={{
                      fontSize: '10.0pt',
                      fontFamily: '"Calibri",sans-serif',
                      color: 'black'
                    }}>

              Session
            </span>
              </p>
            </td>
          </tr>
          </tbody>
        </table>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-GB"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <h1
          style={{
            marginTop: '0cm',
            marginRight: '11.0pt',
            marginBottom: '11.0pt',
            marginLeft: '1.0cm',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-1.0cm'
          }}>

    <span lang="EN-US">
      3.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span lang="EN-US">HOW TO MANAGE OR DELETE COOKIES?</span>
        </h1>
        <p
          className="MsoNormal"
          style={{
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            lineHeight: '12.0pt'
          }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      We use cookies when providing our Services to make sure you can use and
      enjoy our Services easily.{' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Some of the cookies are essential and we cannot provide our Services
      without them, but there are others that can be turned off.{' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      You have the right to choose whether or not to accept non-essential
      cookies and we have explained how you can exercise this right below.
      However, please note that if you choose to refuse or, at a later stage,
      opt out of certain cookies or other locally stored data, you may not be
      able to use the full functionality of the Services.
      <a name="_cp_text_1_187" />
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      Most devices (in the case of mobile applications) and browsers (in the
      case of web apps and pages){' '}
    </span>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      allow you to change your cookie settings. These settings will typically be
      found in the "options" or "preferences" menu of your browser. This
      lets you control your cookie settings so that you can:
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '21.3pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-21.3pt'
          }}>

    <span lang="EN-GB" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      see what cookies or other locally stored data are used and delete them on
      an individual basis
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '21.3pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-21.3pt'
          }}>

    <span lang="EN-GB" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      block third-party cookies{' '}
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '21.3pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-21.3pt'
          }}>

    <span lang="EN-GB" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      block cookies from particular sites
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '21.3pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-21.3pt'
          }}>

    <span lang="EN-GB" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      block all cookies from being set
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '21.3pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-21.3pt'
          }}>

    <span lang="EN-GB" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      delete all cookies when you close your browser
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      For more information on how to manage popular browsers, please see below:
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '18.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-18.0pt'
          }}>

    <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: 'Symbol', color: 'black' }}>

      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        Cookie settings in Chrome
      </span>
            <span
              lang="EN-GB"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        {' '}
              for web
      </span>
          </a>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      {' '}
            and{' '}
    </span>
          <a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=en">
      <span
              lang="EN-GB"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        Android
      </span>
          </a>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '18.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-18.0pt'
          }}>

    <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: 'Symbol', color: 'black' }}>

      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <a href="http://support.apple.com/kb/PH5042">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        Cookie settings in Safari web
      </span>
          </a>
          <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;and&nbsp;
    </span>
          <a href="http://support.apple.com/kb/HT1677">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        iOS
      </span>
          </a>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '18.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-18.0pt'
          }}>

    <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: 'Symbol', color: 'black' }}>

      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <a href="http://windows.microsoft.com/en-gb/windows7/how-to-manage-cookies-in-internet-explorer-9">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        Cookie settings in Internet Explorer
      </span>
          </a>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginLeft: '18.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-18.0pt'
          }}>

    <span
            lang="EN-US"
            style={{ fontSize: '10.0pt', fontFamily: 'Symbol', color: 'black' }}>

      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <a href="http://support.mozilla.org/en-US/kb/cookies">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        Cookie settings in Firefox
      </span>
          </a>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      You can change the settings for the cookies we use in our Services at any
      time in our preference center.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

          <b>
      <span
              lang="EN-US"
              style={{
                fontSize: '10.0pt',
                fontFamily: '"Calibri",sans-serif',
                color: 'black'
              }}>

        How to opt out of third-party cookie use
      </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      If you want to reduce your settings at any time (for example, if you
      accept all cookies, but later decide you do not want a certain type of
      cookie) you can use your browser settings to remove any third-party
      cookies or similar technologies dropped on your previous visit.{' '}
    </span>
          <span
            lang="EN-SG"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      "To opt out of Google Analytics" use of cookies, a{' '}
    </span>
          <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">
      <span
              lang="EN-SG"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        Chrome browser add-on
      </span>
          </a>
          <span
            lang="EN-SG"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      {' '}
            is available.{' '}
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-SG"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginBottom: '6.0pt',
            textAlign: 'justify',
            textJustify: 'inter-ideograph'
          }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      If you would like to find out more about cookies and their use on the
      Internet, you may find the following link useful:
    </span>
          <span lang="EN-US"> </span>
          <a href="http://www.allaboutcookies.org/">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        All About Cookies
      </span>
          </a>
          <span className="MsoHyperlink">
      <span
              lang="EN-US"
              style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

        .
      </span>
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-SG"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-SG"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <h1
          style={{
            marginTop: '0cm',
            marginRight: '11.0pt',
            marginBottom: '11.0pt',
            marginLeft: '1.0cm',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-1.0cm'
          }}>

    <span lang="EN-US">
      4.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span lang="EN-US">CHANGES TO THIS COOKIES POLICY</span>
        </h1>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      We will update this Cookies Policy to reflect changes in our practices and
      services. When we post changes to this Cookies Policy, we will revise the
      "<i>Last Updated</i>" date at the top of this Cookies Policy. If we make
      any material changes in the way we collect, use, and/or share information
      held in cookies, we will notify you by prominently posting notice of the
      changes when you log in to or use the Services. We recommend that you
      check this page from time to time to inform yourself of any changes to
      this Cookies Policy.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <h1
          style={{
            marginTop: '0cm',
            marginRight: '11.0pt',
            marginBottom: '11.0pt',
            marginLeft: '1.0cm',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-1.0cm'
          }}>

    <span lang="EN-US">
      5.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </span>
          <span lang="EN-US">COOKIES THAT HAVE BEEN SET IN THE PAST</span>
        </h1>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      If you have disabled one or more cookies, we may still use information
      collected from cookies prior to your disabled preference being set,
      however, we will stop using the disabled cookie to collect any further
      information.
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      &nbsp;
    </span>
        </p>
        <h1
          style={{
            marginTop: '0cm',
            marginRight: '11.0pt',
            marginBottom: '11.0pt',
            marginLeft: '1.0cm',
            textAlign: 'justify',
            textJustify: 'inter-ideograph',
            textIndent: '-1.0cm'
          }}>

          <a name="_Ref117523723" />
          <a name="_CONTACT_US" />
          <span lang="EN-US">
      6.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
      </span>
    </span>
          <span lang="EN-US">CONTACT US</span>
        </h1>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-US"
            style={{
              fontSize: '10.0pt',
              fontFamily: '"Calibri",sans-serif',
              color: 'black'
            }}>

      If you have any questions or comments about this Cookies Policy, please
      contact us via email{' '}
    </span>
          <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      at
    </span>
          <span lang="EN-GB" style={{ fontFamily: '"Calibri",sans-serif' }}>
      <a href="mailto:GWB_DPO@tencent.com">GWB_DPO@tencent.com</a>{' '}
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      &nbsp;
    </span>
        </p>
        <p
          className="MsoNormal"
          style={{ textAlign: 'justify', textJustify: 'inter-ideograph' }}>

    <span
            lang="EN-GB"
            style={{ fontSize: '10.0pt', fontFamily: '"Calibri",sans-serif' }}>

      &nbsp;
    </span>
        </p>
      </div>
    </div>);

}